<template>
    <div :class="`col-md-${colSize}`" class="mt-2 mb-3" data-cy="intro-board">
        <article class="pentagon-board text-center" :class="`pentagon-board--${variant}`">
            <h3 class="pentagon-board-name">{{ name }}</h3>
            <p class="pentagon-board-year"><i>{{ year }}</i></p>
            <p v-for="(holder, index) in holders" :key="index" class="pentagon-member-name">
                {{ $t('boards.member', { name: holder }) }}
            </p>
        </article>
    </div>
</template>

<script>
export default {
  name: 'Bestuur',
  props: {
    variant: {
      type: String,
      default: 'former',
      validator: value => ['current', 'former'].indexOf(value) !== -1,
    },
    colSize: {
      required: false,
      default: 12,
    },
    name: {
      type: String,
      required: true,
    },
    year: {
      type: String,
      required: true,
    },
    preases: {
      type: String,
      default: '',
    },
    abactis: {
      type: String,
      default: '',
    },
    questor: {
      type: String,
      default: '',
    },
  },
  computed: {
    // A position without a name is not rendered.
    holders() {
      return [this.preases, this.abactis, this.questor].filter(name => name !== '');
    },
  },
};
</script>

<style>
    .pentagon-board {
        height: 100%;
        padding: 1.25rem 1rem;
        background-color: var(--pentagon-ink-raised);
        border: 1px solid;
        border-radius: 2px;
    }

    .pentagon-board--current {
        border-color: var(--pentagon-crimson);
    }

    .pentagon-board--former {
        border-color: var(--pentagon-forest);
    }

    .pentagon-board-name {
        margin-bottom: 0.25rem;
        font-size: 1.25rem;
    }

    .pentagon-board-year {
        margin-bottom: 0.75rem;
        color: var(--pentagon-parchment);
    }

    .pentagon-member-name {
        margin-bottom: 0;
    }
</style>
